import { render, staticRenderFns } from "./MControl.vue?vue&type=template&id=00070bf5"
import script from "./MControl.vue?vue&type=script&lang=js"
export * from "./MControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports